export class CommonConstants {
  public static readonly COMMON_RADIANS_MULTIPLIER: number = Math.PI / 180000;
  public static readonly COMMON_SCALE: number = 0.01;
  public static readonly COMMON_BACKSCALE: number = 10;
  public static readonly EPSILON: number = 0.08;
  public static readonly DEFAULT_ANTIALIAS: number = 8;

  public static readonly CONSTANT_OFFSET: number = 5000;

  public static readonly DIRECTION_U: string = 'U';
  public static readonly DIRECTION_V: string = 'V';
  public static readonly DIRECTION_N: string = 'N';

  public static readonly DIRECTION_X: string = 'x';
  public static readonly DIRECTION_REVERSED_X: string = '-x';
  public static readonly DIRECTION_Y: string = 'y';
  public static readonly DIRECTION_Z: string = 'z';
}
